import { useTranslation } from 'react-i18next'
import { CloudOff } from 'lucide-react'
import { Switch } from '@/components/ui/Switch'
import { useOfflineModeStore } from '@/store/useOfflineModeStore'

export default function NavOfflineModeToggle() {
  const { t } = useTranslation()
  const isEnabled = useOfflineModeStore(s => s.isOfflineModeEnabled)
  const enable = useOfflineModeStore(s => s.enableOfflineMode)
  const disable = useOfflineModeStore(s => s.disableOfflineMode)

  return (
    <li className="flex w-full">
      <label className="flex h-9 w-full cursor-pointer items-center justify-start gap-2 rounded-md px-2 text-sm text-accent-foreground hover:bg-accent">
        <span className="flex h-5 shrink-0 items-center">
          <CloudOff className="size-4" />
        </span>
        <span className="truncate text-left align-top leading-9">
          {t('offlineMode.settings.title')}
        </span>
        <span className="ml-auto flex h-5 items-center">
          <Switch
            checked={isEnabled}
            onCheckedChange={checked => (checked ? enable() : disable())}
          />
        </span>
      </label>
    </li>
  )
}
